import staffMemberFiltersSignal, {
	setStaffMemberFilters,
} from '@UI/Pages/Agencies/StaffMembers/Filters/Signals/staffMemberFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

type Props = {
	readonly options: ReadonlyArray<{ readonly id: number; readonly name: string }>;
	readonly withLabel?: boolean;
};

const FacilityFilter: React.FC<Props> = ({ options, withLabel = false }) => {
	const currentFilters = useSignalValue(staffMemberFiltersSignal);

	const handleFacilityChange = React.useCallback((facilityId: number | null) => {
		setStaffMemberFilters(staffMemberFiltersSignal.peek().setFacilityId(facilityId));
	}, []);

	return (
		<Dropdown<number>
			name="staffMemberFacility"
			label="Agence"
			isLabelHidden={!withLabel}
			placeholder="Toutes les agences"
			options={[...options]}
			optionLabel="name"
			optionValue="id"
			showClear
			value={currentFilters.facilityId}
			onChange={handleFacilityChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default FacilityFilter;
